
import React, { useState } from 'react';

const PrintRequestModal = ({ isOpen, onClose, file, onSubmit }) => {
  const [size, setSize] = useState('18"x24"');
  const [copies, setCopies] = useState(1);
  const [paper, setPaper] = useState('20#Bond');
  const [productionTime, setProductionTime] = useState('2-3business days');
  const [details, setDetails] = useState('');
  const [deliveryMethod, setDeliveryMethod] = useState('pickup');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [recipientPhone, setRecipientPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const printRequestData = {
        fileName: file.original_name,
        fileId: file._id,
        size,
        copies,
        paper,
        productionTime,
        details,
        deliveryMethod,
        deliveryAddress: deliveryMethod === 'delivery' ? deliveryAddress : '',
        recipientName: deliveryMethod === 'delivery' ? recipientName : '',
        recipientPhone: deliveryMethod === 'delivery' ? recipientPhone : '',
        module: file.module || 'plan', // 添加文件模块信息
      };

      const response = await onSubmit(printRequestData);
      if (response.warning) {
        alert(`${response.message}. ${response.warning}`);
      } else {
        alert('Print request submitted successfully!');
      }
      onClose();
    } catch (error) {
      console.error('Error submitting print request:', error);
      alert('Failed to submit print request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="w-full">
                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Print Request</h3>
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">File Name</label>
                    <p className="mt-1 text-sm text-gray-500">{file?.original_name}</p>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Size</label>
                    <select
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      value={size}
                      onChange={(e) => setSize(e.target.value)}
                      required
                    >
                      <option value='18"x24"'>18"x24"</option>
                      <option value='24"x36"'>24"x36"</option>
                      <option value='30"x42"'>30"x42"</option>
                      <option value='60"x36"'>60"x36"</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Number of copies/sets</label>
                    <select
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      value={copies}
                      onChange={(e) => setCopies(parseInt(e.target.value))}
                      required
                    >
                      {[...Array(20)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Paper</label>
                    <input
                      type="text"
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-gray-100"
                      value={paper}
                      readOnly
                    />
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Production Time</label>
                    <select
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      value={productionTime}
                      onChange={(e) => setProductionTime(e.target.value)}
                      required
                    >
                      <option value="2-3business days">2-3 business days</option>
                      <option value="same day service">Same day service</option>
                      <option value="next day">Next day</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Additional details (optional)</label>
                    <textarea
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      value={details}
                      onChange={(e) => {
                        if (e.target.value.length <= 200) {
                          setDetails(e.target.value);
                        }
                      }}
                      maxLength={200}
                      rows="3"
                      placeholder="Enter any additional details here (max 200 characters)"
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">{details.length}/200</p>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Delivery or Pickup</label>
                    <div className="mt-2">
                      <div className="flex items-center">
                        <input
                          id="pickup"
                          name="deliveryMethod"
                          type="radio"
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                          checked={deliveryMethod === 'pickup'}
                          onChange={() => setDeliveryMethod('pickup')}
                        />
                        <label htmlFor="pickup" className="ml-3 block text-sm font-medium text-gray-700">
                          Pickup
                        </label>
                      </div>
                      <div className="flex items-center mt-2">
                        <input
                          id="delivery"
                          name="deliveryMethod"
                          type="radio"
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                          checked={deliveryMethod === 'delivery'}
                          onChange={() => setDeliveryMethod('delivery')}
                        />
                        <label htmlFor="delivery" className="ml-3 block text-sm font-medium text-gray-700">
                          Delivery
                        </label>
                      </div>
                    </div>
                  </div>

                  {deliveryMethod === 'delivery' && (
                    <div className="border p-3 rounded-md bg-gray-50 mb-4">
                      <div className="mb-3">
                        <label className="block text-sm font-medium text-gray-700">Recipient Name</label>
                        <input
                          type="text"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          value={recipientName}
                          onChange={(e) => setRecipientName(e.target.value)}
                          required={deliveryMethod === 'delivery'}
                          placeholder="Enter recipient name"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="block text-sm font-medium text-gray-700">Delivery Address</label>
                        <textarea
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          value={deliveryAddress}
                          onChange={(e) => setDeliveryAddress(e.target.value)}
                          required={deliveryMethod === 'delivery'}
                          rows="2"
                          placeholder="Enter delivery address"
                        ></textarea>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">Phone Number</label>
                        <input
                          type="tel"
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          value={recipientPhone}
                          onChange={(e) => setRecipientPhone(e.target.value)}
                          required={deliveryMethod === 'delivery'}
                          placeholder="Enter phone number"
                        />
                      </div>
                    </div>
                  )}
                  
                  <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                      type="submit"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Sending...' : 'Send Print Request'}
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={onClose}
                      disabled={isSubmitting}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintRequestModal;
